module.exports = __webpack_public_path__ + "img/CCLF_infographic-04.28c4f08b.png";